export const PP_EDIT_DEFAULTS = {
  heroImage: "https://firebasestorage.googleapis.com/v0/b/pp-studio-website.firebasestorage.app/o/library%2Fother%2F1786823623104_PP%20Edit%20.png?alt=media&token=5f9574d7-6b56-4980-990e-4523a5959679",
  keepsakePhoto: "https://firebasestorage.googleapis.com/v0/b/pp-studio-website.firebasestorage.app/o/library%2Fother%2F1786826190199_PP%20Edit%202.png?alt=media&token=86c558b6-6c5e-4249-b5d6-33ce8ae7cf6d",
  kicker: "Pooja's personal edit",
  title: "The PP Edit",
  subtitle: "A personal space for what is on Pooja's mind: work, contracts, ambition, people, lessons, and the quiet moments in between.",
  themeLine1: "Personal reflections",
  themeLine2: "Lessons from work and life",
  themeLine3: "Contracts, people, and perspective",
  searchPlaceholder: "Search articles, topics, tags…",
  browseNote: "Browse by thought, feeling, lesson, client moment, or business question.",
  featuredLabel: "From the keepsake box",
  recentLabel: "Latest entries",
  currentlyLabel: "Right now",
  currentlyReading: "Whatever's on my nightstand this week — contracts by day, fiction by night.",
  currentlyThinking: "How to make ‘boring’ legal advice feel like a conversation, not a lecture.",
  currentlyGrateful: "Clients who trust me with more than just their paperwork.",
  background: "#FFF0F5",
  paper: "#FFF0F5",
  ink: "#3f3027",
  accent: "#9b4d37",
  fadedAccent: "#FFE4E1",
  texture: 42,
  photoStyle: "faded",
  cardStyle: "postcard",
  columns: "3",
  motion: true,
};
